import axios from "axios";
import url1 from '../../config.js'
const url=`${url1.url}/api/lesson`;

export default class Lesson {
    constructor(lesson = {}) {
        this.lessonId = lesson.lessonId || "";
        this.lessonTitle=lesson.lessonTitle||"";
        this.lessonDescription=lesson.lessonDescription||"",
        this.lessonIntroduction=lesson.lessonIntroduction||"",
        this.lessonInstruction=lesson.lessonInstruction||"",
        this.lessonStatementKeySequenceArray=lesson.lessonStatementKeySequenceArray||[],
        this.lessonMaxWrongCount=lesson.lessonMaxWrongCount||0,
        this.lessonStatus = lesson.lessonStatus || true,
        this.lessonStatus = lesson.lessonStatus || true,
        this.isPaid = lesson.isPaid || false

        this.lessonRiyaazTitle=lesson.lessonRiyaazTitle||"",
        this.lessonSequenceNumber=lesson.lessonSequenceNumber||0
    }

    static getLessons = async (token) => {
         return  axios.get(`${url}/lessons`, {headers:{"x-auth-token":token}});
    }

        //to get all lesson count in Dashboard.vue page
    static getLessonCount = async (token) => {
            return  axios.get(`${url}/lessoncount`, {headers:{"x-auth-token":token}});
    }

    static getLessonInfo = async ( lesson_id, token) => {
            console.log('lessoninfo lesson_id', lesson_id);
            return  axios.get(`${url}/lessoninfo/${lesson_id}`, {headers:{"x-auth-token":token}});
    }

    static deleteLesson= async (lesson_id, token)=> {
            return (
                confirm("Are you sure you want to delete this lesson?") &&
                axios.delete(`${url}/lesson/${lesson_id}`, {headers:{"x-auth-token":token}})
            )
    }

    // static putLessonStatus=async ( lesson_id, lessonStatus, token)=> {
    //             return axios.put(`${url}/changelessonstatus/${lesson_id}`, {lessonStatus:lessonStatus}, {headers:{"x-auth-token":token}});
    //     }

    static postLesson =async(lesson, token) =>{
            console.log("lesson model", lesson);
            return axios.post(`${url}/newlesson`, lesson, {headers:{'x-auth-token':token}});
    }

    static putLesson=async ( lesson_id, lesson, token)=> {
            return axios.put(`${url}/updatelesson/${lesson_id}`, lesson, {headers:{"x-auth-token":token}});
    }

    static putLessionPaidStatus=async ( lesson_id, paidstatus, token)=> {
        return axios.put(`${url}/updatelessonpaidstatus/${lesson_id}`,  {lessonPaidStatus:paidstatus}, {headers:{"x-auth-token":token}});
}


    static putRiyaazTitleMaxWrongCount=async(lesson_id,lessonRiyaazTitle,lessonMaxWrongCount, token)=>{
        return axios.put(`${url}/putriyaaztitlemaxwrongcount/${lesson_id}`,{lessonRiyaazTitle:lessonRiyaazTitle, lessonMaxWrongCount:lessonMaxWrongCount}, {headers:{'x-auth-token':token}});
    }

    static saveLessonsNewSequence=async(itemsPerPage,pageNumber,modifiedLessonsSubArraySequence, token)=>{
        return axios.put(`${url}/changelessonssubarraysequence`,{itemsPerPage, pageNumber, modifiedLessonsSubArraySequence}, {headers:{'x-auth-token':token}});
    }

}